import { CLOSE_NAVIGATION, OPEN_NAVIGATION, TOGGLE_NAVIGATION } from './types';

export const closeNavigation = () => ({ type: CLOSE_NAVIGATION });
export const openNavigation = () => ({ type: OPEN_NAVIGATION });
export const toggleNavigation = () => ({ type: TOGGLE_NAVIGATION });
